import { gql } from 'apollo-angular';

export const GET_VEHICLE_TYPES = gql`
query GetVehicleTypes {
  vehicleTypes {
    id
    name
    slug
    vehicleSelection
  }
}
`;
